import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { SharedModule } from '@shared/shared.module';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { BehaviorSubject, Observable } from 'rxjs';

export enum InfoBlockType {
  COVER,
  CENTER,
}

export enum InfoBlockLinkType {
  ROUTE,
  HREF,
  ACTION,
}

export interface InfoBlockConfig {
  type: InfoBlockType;
  title: {
    main: string;
    emphasis?: string;
  };
  button: {
    link: string | string[];
    type: InfoBlockLinkType;
    text: string;
    ariaLabel: string;
    icon?: string;
  };
  img: {
    src: string;
    width?: number;
    height?: number;
  };
}

@Component({
  selector: 'app-info-block',
  templateUrl: './info-block.component.html',
  styleUrls: ['./info-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBlockComponent {
  private static Counter = 0;
  private readonly _id = `wzb-info-block-${++InfoBlockComponent.Counter}`;

  detailsAreOpen$ = new BehaviorSubject<boolean>(false);

  @Input() infoBlockConfig!: InfoBlockConfig;
  @Input() id?: string;
  @Input() withExpansionPanel = false;
  @Output() actionClicked = new EventEmitter<void>();

  InfoBlockLinkType = InfoBlockLinkType;

  get elm_id(): string {
    return this.id ?? this._id;
  }

  @Output() tracker = new EventEmitter<Event>();

  get isMobile$(): Observable<boolean> {
    return this.breakpoints.isMobile$;
  }

  get isTablet$(): Observable<boolean> {
    return this.breakpoints.isTabletPortrait$;
  }

  get imgWidth(): number {
    return this.infoBlockConfig.type === InfoBlockType.CENTER ? 140 : 250;
  }

  get isCentered(): boolean {
    return this.infoBlockConfig.type === InfoBlockType.CENTER;
  }

  get isCover(): boolean {
    return this.infoBlockConfig.type === InfoBlockType.COVER;
  }

  get isRoute(): boolean {
    return this.infoBlockConfig.button.type === InfoBlockLinkType.ROUTE;
  }

  get isHREF(): boolean {
    return this.infoBlockConfig.button.type === InfoBlockLinkType.HREF;
  }

  toggleDetails(): void {
    this.detailsAreOpen$.next(!this.detailsAreOpen$.value);
  }

  constructor(private readonly breakpoints: BreakpointsService) {}

  trackerEvent(): void {
    this.tracker.emit();
  }
}

@NgModule({
  imports: [CommonModule, ImaginarySrcModule, SharedModule, MatIconModule],
  declarations: [InfoBlockComponent],
  exports: [InfoBlockComponent],
})
export class InfoBlockModule {}
